import { type ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import routes from "@/configs/configRotas/config-rotas";
import { DEFAULT_COOKIE_EXPIRES_SECONDS, getCookie, setCookie } from "@/utils/cookie";
import AppContext, { type AppContextType } from "./AppContext";

const COOKIE_SHOW_SENSITIVE_VALUES = "showSensitiveValues";

type AppContextProviderProps = {
	readonly children: ReactNode;
};

function getInitialShowSensitiveValues() {
	const saved = getCookie(COOKIE_SHOW_SENSITIVE_VALUES);

	if (saved === "true") return true;
	if (saved === "false") return false;

	return true;
}

export function AppContextProvider({ children }: AppContextProviderProps) {
	const [showSensitiveValues, setShowSensitiveValues] = useState(getInitialShowSensitiveValues);

	const toggleSensitiveValues = useCallback(() => {
		setShowSensitiveValues((current) => !current);
	}, []);

	useEffect(() => {
		setCookie(COOKIE_SHOW_SENSITIVE_VALUES, String(showSensitiveValues), {
			path: "/",
			expires: DEFAULT_COOKIE_EXPIRES_SECONDS.oneWeek,
		});
	}, [showSensitiveValues]);

	const value = useMemo<AppContextType>(
		() => ({
			routes: routes,
			showSensitiveValues,
			setShowSensitiveValues,
			toggleSensitiveValues,
		}),
		[showSensitiveValues, toggleSensitiveValues],
	);

	return <AppContext value={value}>{children}</AppContext>;
}
